import { render } from "./review-score.vue?vue&type=template&id=495473aa"
import script from "./review-score.vue?vue&type=script&lang=js"
export * from "./review-score.vue?vue&type=script&lang=js"

import "./review-score.vue?vue&type=style&index=0&id=495473aa&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-testimonial/review-score.vue'],['render',render],['__file',"review-score.vue"]])

export default __exports__